import {Button} from "@luciad/ria-sample-common/components/button/Button";
import React from "react";
import "./WizardPreviousNextButtons.css";

interface Props {
  onPrevious: () => void;
  onNext: () => void;
  previousLabel?: string;
  nextLabel?: string;
}

export const WizardPreviousNextButtons = ({
                                            onPrevious,
                                            onNext,
                                            previousLabel = "Previous",
                                            nextLabel = "Next"
                                          }: Props) => {
  return (
      <div className="previous-next-buttons">
        <Button type="button" onClick={() => onPrevious()}>{previousLabel}</Button>
        <Button type="button" onClick={() => onNext()}>{nextLabel}</Button>
      </div>
  )
}